import Accordion from "react-bootstrap/Accordion";
import { Col, Row } from "react-bootstrap";

function ClientAccordionComponent() {
  return (
    <Row>
      <Col lg={6} xl={4} md={6}>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>Content</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>Static Content Caching</li>
                <li>Dynamic Content Routing</li>
                <li>Cache purging</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>Security</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>Static Content Caching</li>
                <li>Dynamic Content Routing</li>
                <li>Cache purging</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>Functionality</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>Static Content Caching</li>
                <li>Dynamic Content Routing</li>
                <li>Cache purging</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>Network Security Solutions</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>GIS Software</li>
                <li>Computer-Aided Manufacturing (CAM) Software</li>
                <li>Product Data Management (PDM) Software</li>
                <li>PCB Design Software</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Col>
      <Col lg={6} xl={4} md={6}>
        <Accordion defaultActiveKey="4">
          <Accordion.Item eventKey="4">
            <Accordion.Header>Analysis</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>Logging and Reporting</li>
                <li>Issue Tracking</li>
                <li>Security Monitoring</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5">
            <Accordion.Header>Integration</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>Logging and Reporting</li>
                <li>Issue Tracking</li>
                <li>Security Monitoring</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Col>
      <Col lg={6} xl={4} md={6}>
        <Accordion defaultActiveKey="7">
          <Accordion.Item eventKey="7">
            <Accordion.Header>Management</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>Dashboard</li>
                <li>Reports</li>
                <li>Logs</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="8">
            <Accordion.Header>Controls</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>Dashboard</li>
                <li>Reports</li>
                <li>Logs</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Col>
    </Row>
  );
}

export default ClientAccordionComponent;
